import moment from 'moment';
import { NATIONAL_HOLIDAYS } from '../constants';

// Função extraída e ajustada do componente de calendário do Design System
const addDays = (date: Date, days: number) => {
  const copy = new Date(Number(date));
  copy.setDate(date.getDate() + days);

  const result = {
    day: `${copy.getDate()}`,
    month: `${copy.getMonth() + 1}`,
  };

  result.day = result.day.length === 1 ? `0${result.day}` : `${result.day}`;
  result.month = result.month.length === 1 ? `0${result.month}` : `${result.month}`;

  return result;
};

// Função extraída e ajustada do componente de calendário do Design System
const getEaster = (date: string) => {
  const year = new Date(date).getFullYear();
  const f = Math.floor;
  const G = year % 19;
  const C = f(year / 100);
  const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
  const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
  const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
  const L = I - J;
  const month = 3 + f((L + 40) / 44);
  const day = L + 28 - 31 * f(month / 4);

  return { month, day };
};

// Função extraída e ajustada do componente de calendário do Design System
const getMoveDate = (moveDays: number, selectedDate: string) => {
  const object = getEaster(selectedDate);
  const actualYear = new Date(selectedDate).getFullYear();
  const date = new Date(`${actualYear} ${object.month} ${object.day}`);
  const result = addDays(date, moveDays);

  return result;
};

// Função extraída e ajustada do componente de calendário do Design System (getHolidaysByDate)
export const isDateAHoliday = (date: string) => {
  const formattedDate = moment(date).format('DD/MM');

  return NATIONAL_HOLIDAYS.some((holiday) => {
    if (!holiday.move) {
      return holiday.data === formattedDate;
    }

    const dateObject = {
      day: formattedDate.slice(0, 2),
      month: formattedDate.slice(3, 5),
    };

    const moveDate = getMoveDate(holiday.move, date);

    return moveDate.day === dateObject.day && moveDate.month === dateObject.month;
  });
};
